import client from '@/api/client';
import { gql } from '@apollo/client';

const getCourseSession = (studentId: number) => client
  .query({
    query: gql`
      query($studentId: Int) {
        getCourseSession(studentId: $studentId) {
          id
          progress
          createdAt
          updatedAt
          nextLesson {
            id
          }
          course {
            id
            titleEn
            lessonsCounter
            lessons {
              title
              id
              description
              grammarTheme
              images {
                path
                size
              }
              lessonProgress {
                id
              }
            }
          }
          studentsList {
            teacher {
              name
              skype
              user {
                avatar {
                  path
                  size
                }
              }
            }
            schedule
            trial
          }
          courseStatistics {
            id
            lessons {
              id
              homeWorkComplete
              testExist
              testComplete
            }
          }
        }
      }
    `,
    variables: {
      studentId,
    },
  });

export default {
  getCourseSession,
};
